module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h2', {
    staticClass: "h4",
    on: {
      "click": function($event) {
        _vm.mostrar = false
      }
    }
  }, [_vm._v("Agência")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required col-md-12",
    class: {
      'has-error': _vm.errors.first('agencia')
    },
    attrs: {
      "uib-tooltip": "Prefixo da Agência"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "agencia"
    },
    on: {
      "click": function($event) {
        _vm.mostrar = false
      }
    }
  }, [_vm._v("Agência:")]), _vm._v(" "), (_vm.propsProposta.ds_agencia_nome && _vm.mostrar === false) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_agencia_nome),
      expression: "proposta.ds_agencia_nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "prefixo",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_agencia_nome)
    },
    on: {
      "click": function($event) {
        _vm.mostrar = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_agencia_nome", $event.target.value)
      }
    }
  })]) : (_vm.mostrar === true) ? _c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "font-size": "4px"
    },
    attrs: {
      "options": _vm.agencias,
      "custom-label": _vm.numeroNomeAgencia,
      "placeholder": "Selecione uma agência",
      "label": "type",
      "track-by": "type",
      "preselect-first": false,
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "selectedLabel": "",
      "name": "agencia"
    },
    on: {
      "open": _vm.buscaAgencias,
      "select": _vm.buscaAgencia
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.agenciaSelecionada),
      callback: function($$v) {
        _vm.agenciaSelecionada = $$v
      },
      expression: "agenciaSelecionada"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.errors.first('agencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CNPJ agência')
    },
    attrs: {
      "uib-tooltip": "CNPJ da Agência"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "CNPJ agência"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255|cnpj'),
      expression: "'required|max:255|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ agência",
      "id": "CNPJ agência",
      "mask": ['NN.NNN.NNN/NNNN-##'],
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.proposta.ds_agencia_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_agencia_cnpj", $$v)
      },
      expression: "proposta.ds_agencia_cnpj"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('endereço da agência')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "endereço da agência"
    }
  }, [_vm._v("Endereço da agência:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_agencia_endereco),
      expression: "proposta.ds_agencia_endereco"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "endereço da agência",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_agencia_endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_agencia_endereco", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('endereço da agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço da agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('telefone agência')
    },
    attrs: {
      "uib-tooltip": "Telefone da agência"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "telefone agência"
    }
  }, [_vm._v("Telefone da agência:")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "telefone agência",
      "id": "telefone agência",
      "mask": ['####-####', '(##) ####-####', '(##) #####-####'],
      "type": "text",
      "maxlength": "255"
    },
    model: {
      value: (_vm.proposta.ds_agencia_telefone),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_agencia_telefone", $$v)
      },
      expression: "proposta.ds_agencia_telefone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('telefone agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('email agência')
    },
    attrs: {
      "uib-tooltip": "E-mail da agência"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email agência"
    }
  }, [_vm._v("E-mail da agência:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_agencia_email),
      expression: "proposta.ds_agencia_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255|email'),
      expression: "'required|max:255|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email agência",
      "type": "email",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_agencia_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_agencia_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('email agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email agência')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Gerente")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('nome gerente')
    },
    attrs: {
      "uib-tooltip": "Nome do Gerente"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "nome gerente"
    }
  }, [_vm._v("Nome do Gerente:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_gerente_nome),
      expression: "proposta.ds_gerente_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome gerente",
      "id": "nome gerente",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_gerente_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_gerente_nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('profissão do gerente')
    },
    attrs: {
      "uib-tooltip": "Profissão do Gerente"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "profissão do gerente"
    }
  }, [_vm._v("Profissão:")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.managerOccupation",
      "approval": "propSimpleCtrl.approval",
      "state": "propSimpleCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_gerente_profissao),
      expression: "proposta.ds_gerente_profissao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "profissão do gerente",
      "id": "profissão do gerente",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_gerente_profissao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_gerente_profissao", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('profissão do gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('profissão do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('uf gerente')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "uf gerente"
    }
  }, [_vm._v(" UF: ")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_gerente_uf),
      expression: "proposta.ds_gerente_uf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "uf gerente",
      "id": "uf gerente"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.proposta, "ds_gerente_uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.proposta.ds_gerente_uf,
      "selected": _vm.proposta.ds_gerente_uf
    }
  }, [_vm._v(_vm._s(_vm.proposta.ds_gerente_uf))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('uf gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('uf gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('cidade do gerente')
    },
    attrs: {
      "uib-tooltip": "Cidade do Gerente"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cidade do gerente"
    }
  }, [_vm._v("Cidade:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_gerente_cidade),
      expression: "proposta.ds_gerente_cidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cidade do gerente",
      "id": "cidade do gerente",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_gerente_cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_gerente_cidade", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('cidade do gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cidade do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('estado civil gerente')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "estado civil gerente"
    }
  }, [_vm._v("Estado Civil:")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_gerente_estado_civil),
      expression: "proposta.ds_gerente_estado_civil"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estado civil gerente",
      "id": "estado civil gerente"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.proposta, "ds_gerente_estado_civil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.proposta.ds_gerente_estado_civil,
      "selected": _vm.proposta.ds_gerente_estado_civil
    }
  }, [_vm._v(_vm._s(_vm.proposta.ds_gerente_estado_civil))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOLTEIRO"
    }
  }, [_vm._v("Solteiro(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CASADO"
    }
  }, [_vm._v("Casado(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DIVORCIADO"
    }
  }, [_vm._v("Divorciado(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIUVO"
    }
  }, [_vm._v("Viúvo(a)")])])]), _vm._v(" "), (_vm.errors.first('estado civil gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('estado civil gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CPF gerente')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "managerCpf"
    }
  }, [_vm._v(" CPF: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:11|cpf'),
      expression: "'required|max:11|cpf'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CPF gerente",
      "id": "CPF gerente",
      "mask": ['###.###.###-##']
    },
    model: {
      value: (_vm.proposta.ds_gerente_cpf),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_gerente_cpf", $$v)
      },
      expression: "proposta.ds_gerente_cpf"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CPF gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CPF gerente')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Funcionário agência")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('matrícula do funcionário')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "matrícula do funcionário"
    }
  }, [_vm._v(" Matrícula do funcionário: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|length:7'),
      expression: "'required|length:7'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "matrícula do funcionário",
      "placeholder": "Insira a matricula. Somente números e sem dígito.",
      "mask": '#######'
    },
    nativeOn: {
      "change": function($event) {
        return _vm.selectFuncionario(_vm.proposta.ds_funcionario_matricula)
      }
    },
    model: {
      value: (_vm.proposta.ds_funcionario_matricula),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_funcionario_matricula", $$v)
      },
      expression: "proposta.ds_funcionario_matricula"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('matrícula do funcionário')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('matrícula do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('funcionário responsável')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "funcionário responsável"
    }
  }, [_vm._v(" Funcionário responsável pelo projeto: ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_funcionario_nome),
      expression: "proposta.ds_funcionario_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "funcionário responsável",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_funcionario_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_funcionario_nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('funcionário responsável')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('funcionário responsável')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('telefone do funcionário')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "telefone do funcionário"
    }
  }, [_vm._v(" Telefone fixo: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "mask": ['(##) ####-####', '(##) #####-####'],
      "name": "telefone do funcionário",
      "type": "text"
    },
    model: {
      value: (_vm.proposta.ds_funcionario_telefone),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_funcionario_telefone", $$v)
      },
      expression: "proposta.ds_funcionario_telefone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('telefone do funcionário')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required col-md-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "e-mail funcionário"
    }
  }, [_vm._v(" E-mail do funcionário: ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_funcionario_email),
      expression: "proposta.ds_funcionario_email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "e-mail funcionário",
      "id": "e-mail funcionário",
      "type": "email"
    },
    domProps: {
      "value": (_vm.proposta.ds_funcionario_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_funcionario_email", $event.target.value)
      }
    }
  })])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Agência condutora do projeto")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01fea68d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/agenciaCondutoraProjeto.vue
// module id = 1845
// module chunks = 1